module.exports = __webpack_public_path__ + "img/providers.e5f45712.jpg";